// @flow

import { empty } from '../constants';

import type {
  MatchState,
} from './types';
import { learningOrder } from '../types';

const initialState: MatchState = {
  currentGameId: null,
  currentGameState: null,
  events: [],
  games: [],
  gameStates: [],
  sessionCreated: false,
  sessionId: null,
  learningOrder: learningOrder.LINEAR,
  reviewedContents: [],
  requestedQuestionsCount: 0,
  hasMore: false,
  answeredFacts: {},
  uniqueAnswers: {},
  reviewGameState: null,
  sessionMeta: {},
  answeredEvents: 0,
};

export {
  initialState,
  empty,
};
